import React from 'react';
import { BrazeContentCardFeedContext } from '../../components/shared/BrazeContentCard/BrazeContentCardFeedContext';

export const useBrazeContentCards = () => React.useContext(BrazeContentCardFeedContext);
